import { useLocalObservable } from "mobx-react-lite";
import React, { createContext, ReactNode } from "react";
import { PatientsApi, StorageApi } from "../../api-client";
import { AuthContext } from "../Auth/auth.provider";
import useStore from "../../helpers/useStore";
import { createApiConfig } from "../../api/createApiConfig";
import StorageStore from "./StorageStore";

interface StorageProviderProps {
  children: ReactNode;
}

export const StorageContext = createContext<StorageStore | null>(null);

 const StorageProvider = ({ children }: StorageProviderProps) => {
   const AuthenticationStore = useStore(AuthContext);

  const apiClient = new StorageApi(createApiConfig());

  const store = useLocalObservable(() => new StorageStore(apiClient, AuthenticationStore));

  store.apiClient = apiClient;

  return <StorageContext.Provider value={store}>{children}</StorageContext.Provider>;
};

export default StorageProvider;


